import React, { FC } from 'react';
import moment from 'moment';

import { entry } from 'assets/icons';
import { Tooltip } from 'components/atoms/tooltip';
import { SvgWrapper } from 'components/atoms/svg-wrapper';

import styles from './styles.module.css';

interface IOccupantProps {
  name: string;
  enteredAt: string;
}

export const Occupant: FC<IOccupantProps> = ({ name, enteredAt }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.text}>{name}</div>
      <div className={styles.date}>
        <Tooltip text={'Entered at'}>
          <SvgWrapper width={22} height={22} details={entry} />
        </Tooltip>
        <div className={styles.text}>{moment(enteredAt).format('YYYY-MM-DD, HH:MM:SS')}</div>
      </div>
    </div>
  );
};
